import {Component, h} from 'preact'
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {Collection, EditorialLayout} from "../../models/collection";
import {FilterMap} from "../../models/filter";
import {Product} from "../../models/product";
import SinglePortrait from "./single-portrait";
import PortraitOnly from "./portrait-only";
import {productService} from "../../services/product-service";
import App from "../app";

interface Props {
    collections: Collection[];
    filters: FilterMap;
    isMobile: boolean;
    initialized: boolean;
}

interface State {
    collection: Collection;
    products: Product[]
}

const mapToProps = ({collections, filters, initialized}) => ({collections, filters, initialized});


class Editorial extends Component<Props, State> {

    state: State = {
        collection: null,
        products: null,
    };

    async componentDidMount(): Promise<void> {
        const filter = this.props.filters.editorials.find(f => f.selected);
        await this.loadEditorial(filter.value.toString());
    }

    async componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): Promise<void> {
        const nextFilter = nextProps.filters.editorials.find(f => f.selected);

        // only reload the collection and its products when the id has changed
        if (nextFilter.value.toString() !== this.state.collection.id) {
            await this.loadEditorial(nextFilter.value.toString());
        }
    }

    async loadEditorial(collectionId: string) {
        const collection = await productService.loadCollections(collectionId, App.countryCode);
        const products = collection[0].extractProducts().filter((product, index, self) => self.findIndex(p => p.variants[0].productId === product.variants[0].productId) === index);
        this.setState({collection: collection[0], products: products.sort()});
    }

    render(props: Readonly<Props>, state: Readonly<State>) {
        if (!this.props.initialized || !this.state.collection || this.state.products.length <= 0) {
            return;
        }

        switch (this.state.collection.editorial_layout) {
            case EditorialLayout.SINGLE_PORTRAIT:
                return <SinglePortrait collection={this.state.collection} products={this.state.products}/>
            case EditorialLayout.PORTRAIT_ONLY:
                return <PortraitOnly collection={this.state.collection} products={this.state.products}/>
            default:
                return <SinglePortrait collection={this.state.collection} products={this.state.products}/>
        }
    }
}

export default connect(mapToProps, actions)(withDeviceIndicator(Editorial))
